//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("cisScreening", CisScreeningFactory);

    CisScreeningFactory.$inject = ["apiClientFactory"];
    function CisScreeningFactory(apiClientFactory) {

        const routePrefix = "api/Cis/Screening/";

        return {
            Accept: apiClientFactory.patch(routePrefix + "Accept/"),
            RegisterAudit: apiClientFactory.post(routePrefix + "InspectionResults/"),
            Reject: apiClientFactory.patch(routePrefix + "Reject/"),
            Search: apiClientFactory.post(routePrefix + "Search/"),
        };
    }
})();
